import 'react-polymer';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { fetchPlayer, fetchAnonymous, fetchPlayerLocation, switchPlayerLocation, openAssessment, closeAssessment } from '../../actions/player';
import { fetchTimeseries } from '../../actions/timeseries';
import { setWindow } from '../../actions/config';
import { storeIp } from '../../api';

import PageHeader from '../../components/PageHeader';
import ScoreCards from '../../components/ScoreCards';
import localize from '../../components/localize';
import Leaderboard from '../../components/Leaderboard';
import Comparison from '../../components/Comparison';
import Timeseries from '../../components/Timeseries';
import Tip from '../../components/Tip';
import HelpButton from '../../components/HelpModal';
import LocationSearch from '../../components/Search';
import AppHeader from '../../components/AppHeader';
import NavBar from '../../components/NavBar';
import Disclaimer from '../../components/Disclaimer';
import Cookies from 'js-cookie';
import Location from '../../components/Location';
import NoticeWindow from '../../components/NoticeWindow';
import TimeSelector from '../../components/TimeSelector';
import LocationSelector from '../../components/LocationSelector';

import getIspData from '../../utils/get_isp_data';

import './MyScore.css';

const UnsupportedLocation = localize('pages.scores.unsupportedLocation')(({ i18n, location }) => (
  <div className="centered-content">
    <div className="unsupported-location notice-window">
      <PageHeader i18nPath={i18n.path()} />

      <p dangerouslySetInnerHTML={{ __html: i18n.t('content') }}></p>

      { location && <p className="caps-case"><Location location={location} /></p> }
    </div>
  </div>
));

const NoResults = localize('pages.scores.noresults')(({ i18n }) => (
  <NoticeWindow i18n={i18n} className='no-results' />
));

class CookieBlock extends Component {
  static cookieShards = ['euw', 'eune'];
  static cookieName = 'LagReportWaiver';

  disclosureRequired() {
    return CookieBlock.cookieShards.indexOf(this.props.shard) >= 0 && !Cookies.get(CookieBlock.cookieName);
  }

  onAgreeClicked() {
    Cookies.set(CookieBlock.cookieName, 'agreed');
    storeIp(this.props.shard);
    this.forceUpdate(); //force this since display is dependent on cookie state.
  }

  render() {
    const { shard, children, i18n } = this.props;

    if(this.disclosureRequired()) {
      return <div>
                <div className="centered-content">
                  <div className="notice-window">
                    <PageHeader i18nPath={i18n.path()} />

                    <p className="notice-text">{i18n.t('content')}</p>

                    <q-button onClick={() => this.onAgreeClicked()}>{i18n.t('agree')}</q-button>

                    <p className="text-center privacy-policy"><a href={i18n.t('privacy_policy_url')}>{i18n.t('privacy_policy')}</a></p>
                   </div>
                 </div>

                 <LocationSearch shard={shard} />
              </div>;
    } else {
      return <div>{children}</div>;
    }
  }
}

CookieBlock = compose(localize('pages.scores.cookieDisclosure'), connect(store => {
  return {
    shard: store.config.shard
  }
}))(CookieBlock);

// const MobileMessage = localize('pages.scores.mobileMessage')(({ i18n }) => (
//   <NoticeWindow i18n={i18n} className='mobile-message' />
// ));

const PlayerNotFoundBare = ({ i18n }) => (
  <NoticeWindow i18n={i18n} className='player-not-found' />
);

const PlayerNotFound = localize('errors.playerNotFound')(PlayerNotFoundBare);

const LoadingErrorBare = ({ i18n }) => (
  <NoticeWindow i18n={i18n} className='loading-error' />
);

const LoadingError = localize('errors.loading')(LoadingErrorBare);

class MyScore extends Component {
  componentDidMount() {
    this.fetchPlayer();
  }

  componentDidUpdate() {
    this.fetchPlayer();
  }

  fetchPlayer() {
    const { shard } = this.props;

    if(this.props.isLoggedIn) {
      this.props.fetchPlayer(shard);
    } else {
      this.props.fetchAnonymous(shard);
    }

    if (this.props.isLoggedIn && this.props.player.isLoaded && !this.props.player.location.data_loaded) {
      this.props.fetchPlayerLocation(shard)
    }
  }

  renderPlayer() {
    const { player: { location }, player, i18n, timeWindow, setWindow, switchPlayerLocation, shard, timeseries, fetchTimeseries } = this.props;
    const filteredPlayer = { ...player }

    filteredPlayer.location = { ...location }
    filteredPlayer.location.isps = filteredPlayer.location.isps.filter(i => getIspData(i.stats, timeWindow))

    return <div>
              <div>
                <LocationSelector player={filteredPlayer} switchPlayerLocation={switchPlayerLocation} shard={shard} />
              </div>
              <div className="results-header centered-content">
                <div>
                  <h1>
                    <div className="results-text">
                      { i18n.t('header') }
                    </div>
                    <HelpButton i18nPath={i18n.path('help')} />
                  </h1>
                </div>
              </div>
              <div>
                <TimeSelector timeWindow={timeWindow} setWindow={setWindow}/>
              </div>
              <div className="centered-content">
                <ScoreCards {...this.props} player={filteredPlayer} />
              </div>
              { player.isLoggedIn && getIspData(player.stats, timeWindow) && getIspData(player.stats, timeWindow).stats_wireless && !getIspData(player.stats, timeWindow).stats_ethernet ? <Tip name="wifi" /> : [] }
              {filteredPlayer.location.isps.length > 0 &&
                <div className="leaderboard-area">
                  <PageHeader i18nPath={i18n.path('leaderboard')} />
                  <div>
                    <TimeSelector timeWindow={timeWindow} setWindow={setWindow}/>
                  </div>
                  <div className="centered-content"><Leaderboard activeIsp={player.isp} location={filteredPlayer.location} timeWindow={timeWindow} /></div>
                </div> }
              {filteredPlayer.location.isps.length === 0 && <NoResults />}
              {filteredPlayer.location.isps.length > 1 &&
                <div className="centered-content">
                  <PageHeader i18nPath={i18n.path('compare')} />
                  <Comparison isps={filteredPlayer.location.isps} playerIsp={player.isp} location={location.location} fetchTimeseries={fetchTimeseries} timeseries={timeseries} shard={shard}/>
                </div>}
              {filteredPlayer.location.isps.length === 1 &&
                <div className="centered-content">
                  <div className="single-timeseries">
                    <Timeseries dataA={filteredPlayer.location.isps[0]} dataB={{}} compareKey="connection_score" single={true} location={location.location} fetchTimeseries={fetchTimeseries} timeseries={timeseries} shard={shard}/>
                  </div>
                </div>}
              <div className="disclaimer-footer">
                <Disclaimer />
              </div>
            </div>;
  }

  renderSearch() {
    const { player: { isLoaded, location }, shard} = this.props;

    return <LocationSearch currentLocation={isLoaded && !location.unsupported_country && location.location} shard={shard} />;
  }

  renderUnsupported() {
    const { player: { location: { location } } } = this.props;

    return <div>
            <UnsupportedLocation location={location} />
            {this.renderSearch()}
           </div>;
  }

  renderError() {
    const { player: { isNotFound } } = this.props;

    return isNotFound ? <PlayerNotFound /> : <LoadingError />;
  }

  render() {
    const { player: { location, isLoaded, isLoggedIn, isError } } = this.props;

    if(!isLoaded || (isLoggedIn && !location.data_loaded) || isError) {
      if(isError) {
        return this.renderError();
      } else {
        return this.renderSearch();
      }
    } else {
      return (!location.unsupported_country && this.renderPlayer()) || (location.unsupported_country && this.renderUnsupported());
    }
  }
}

MyScore = compose(localize('pages.scores'), connect((state) => {
  return {
    player: state.player,
    timeseries: state.timeseries,
    riotBarLoaded: state.riotBarLoaded,
    isLoggedIn: state.player.isLoggedIn,
    shard: state.config.shard,
    timeWindow: state.config.timeWindow
  };
}, (dispatch) => {
  return {
    fetchPlayer: (shard) => dispatch(fetchPlayer(shard)),
    fetchTimeseries: (locationId, isp, shard) => dispatch(fetchTimeseries(locationId, isp, shard)),
    fetchAnonymous: (shard) => dispatch(fetchAnonymous(shard)),
    fetchPlayerLocation: (shard) => dispatch(fetchPlayerLocation(shard)),
    setWindow: (timeWindow) => dispatch(setWindow(timeWindow)),
    switchPlayerLocation: (location) => dispatch(switchPlayerLocation(location)),
    openAssessment: () => dispatch(openAssessment()),
    closeAssessment: () => dispatch(closeAssessment())
  }
}))(MyScore);

export default () => (
  <div>
    <AppHeader>
      <NavBar />
    </AppHeader>
    <CookieBlock>
      <MyScore />
    </CookieBlock>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/MyScore/index.js